<template>
    <b-modal
        v-if="show"
        :title="modalTitle"
        v-model="show"
        size="sm"
        centered no-close-on-backdrop
        @cancel="close"
        @close="close"
        @ok="ok">
        <div>
            <p>
                <b>{{ userType }} Number:</b> {{ number }}
            </p>
            <p>
                <b>{{ userType }} Name:</b> {{ name }}
            </p>
            <p>
                <b>{{ userType }} Email:</b> {{ email }}
            </p>
            <b-form-group v-if="status === 'reject'" label="Rejection reason*" label-for="rejection-reason">
                <b-form-input id="rejection-reason" v-model="rejectionReason" placeholder="Rejection reason" :state="isValidRejectionReason()"></b-form-input>
                <b-form-invalid-feedback>Please add a rejection reason</b-form-invalid-feedback>
            </b-form-group>
        </div>

    </b-modal>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component({
})

export default class extends Vue {
  @Prop()
  public email!: string

  @Prop()
  public name!: string

  @Prop()
  public number!: string

  public rejectionReason: string | null = null

  @Prop()
  public modalTitle!: string

  @Prop()
  public show!: boolean

  @Prop()
  public status!: string

  @Prop()
  public userType!: string

  private ok() {
    this.$emit('ok', this.rejectionReason)
  }

  @Emit('close')
  private close() {
    this.show = false
  }

  public isValidRejectionReason() {
    return this.rejectionReason && this.rejectionReason !== ''
  }
}
</script>
